/** Resolve Telegram-style media dims for bubble reservation. */

export type DimsLike = {
  media_width?: number | null;
  mediaWidth?: number | null;
  media_height?: number | null;
  mediaHeight?: number | null;
  message_size?: string | null;
  messageSize?: string | null;
};

export function parseMessageSize(
  raw?: string | null,
): { w: number; h: number } | null {
  if (!raw) return null;
  const m = String(raw).trim().match(/^(\d+)\s*[x×]\s*(\d+)$/i);
  if (!m) return null;
  const w = Number(m[1]);
  const h = Number(m[2]);
  if (!(w > 0) || !(h > 0)) return null;
  return { w, h };
}

export function resolveMediaDims(
  obj?: DimsLike | null,
): { w: number; h: number } | null {
  if (!obj) return null;
  const w = Number(obj.media_width ?? obj.mediaWidth);
  const h = Number(obj.media_height ?? obj.mediaHeight);
  if (Number.isFinite(w) && Number.isFinite(h) && w > 0 && h > 0) {
    return { w: Math.round(w), h: Math.round(h) };
  }
  return parseMessageSize(obj.message_size ?? obj.messageSize);
}

/** "WxH" for LoadingSkeletonImageDynamic dims prop */
export function dimsToMessageSize(obj?: DimsLike | null): string | undefined {
  const d = resolveMediaDims(obj);
  return d ? `${d.w}x${d.h}` : undefined;
}
